"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsAltBox = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
const _excluded = ["children", "sx", "maxHeight"],
  _excluded2 = ["children", "sx"],
  _excluded3 = ["children", "sx"],
  _excluded4 = ["children", "sx"],
  _excluded5 = ["children", "sx"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const DmsAltBoxCard = _ref => {
  let {
      children,
      sx,
      maxHeight
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_material.Card, _extends({
    sx: _objectSpread(_objectSpread({
      display: 'flex',
      flexDirection: 'column',
      wordBreak: 'break-word',
      marginBottom: '1rem',
      width: '100%'
    }, maxHeight && {
      maxHeight: maxHeight,
      overflow: 'hidden'
    }), sx)
  }, props), children);
};
const DmsAltBoxHeader = _ref2 => {
  let {
      children,
      sx
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_react.default.createElement(_material.Box, _extends({
    "data-variant": "dms-alt-box-header",
    sx: _objectSpread({
      display: 'flex',
      justifyContent: 'space-between',
      padding: '0.75rem 1.25rem',
      borderBottom: '1px solid rgba(0, 0, 0, .125)',
      alignItems: 'center',
      bgcolor: 'blue.main',
      color: 'neutral.light'
    }, sx)
  }, props), children);
};
const DmsAltBoxHeaderRight = _ref3 => {
  let {
      children,
      sx
    } = _ref3,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_react.default.createElement(_material.Box, _extends({
    sx: _objectSpread({
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '0.25rem',
      alignItems: 'center'
    }, sx)
  }, props), children);
};
const DmsAltBoxBody = _ref4 => {
  let {
      children,
      sx
    } = _ref4,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_react.default.createElement(_material.Box, _extends({
    sx: _objectSpread({
      flex: '1 1 auto',
      minHeight: '1px',
      padding: '1.25rem',
      overflowY: 'auto'
    }, sx)
  }, props), children);
};
const DmsAltBoxFooter = _ref5 => {
  let {
      children,
      sx
    } = _ref5,
    props = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_react.default.createElement(_material.Box, _extends({
    sx: _objectSpread({
      padding: '0.75rem 1.25rem',
      borderTop: '1px solid rgba(0, 0, 0, .125)'
    }, sx)
  }, props), children);
};

/**
 * DmsAltBox Component
 * 
 * This component is a set of subcomponents designed to create
 * flexible and styled information boxes with various sections.
 * 
 * Components:
 * 
 * 1. DmsAltBoxCard: The main container for the AltBox.
 *    - Props:
 *      - children: The child content to be rendered inside the card.
 *      - sx: Additional styling applied to the component.
 *      - props: Any other properties supported by the Material-UI Card component.
 * 
 * 2. DmsAltBoxHeader: A container for the header section of the AltBox.
 *    - Props:
 *      - children: The child content to be rendered inside the header.
 *      - sx: Additional styling applied to the component.
 *      - props: Any other properties supported by the Material-UI Box component.
 * 
 * 3. DmsAltBoxHeaderRight: A container for right-aligned content within the header.
 *    - Props:
 *      - children: The child content to be rendered inside the right-aligned section.
 *      - sx: Additional styling applied to the component.
 *      - props: Any other properties supported by the Material-UI Box component.
 * 
 * 4. DmsAltBoxBody: The main content area of the AltBox.
 *    - Props:
 *      - children: The child content to be rendered inside the body.
 *      - sx: Additional styling applied to the component.
 *      - props: Any other properties supported by the Material-UI Box component.
 * 
 * 5. DmsAltBoxFooter: A footer section of the AltBox.
 *    - Props:
 *      - children: The child content to be rendered inside the footer.
 *      - sx: Additional styling applied to the component.
 *      - props: Any other properties supported by the Material-UI Box component.
 * 
 * Example Usage:
 * 
 * <DmsAltBox.Card>
 *   <DmsAltBox.Header>
 *     <Typography variant='h3'>Header Title</Typography>
 *     <DmsAltBox.HeaderRight>
 *       <SomeIcon />
 *     </DmsAltBox.HeaderRight>
 *   </DmsAltBox.Header>
 *   <DmsAltBox.Body>
 *     <Typography>Body content goes here.</Typography>
 *   </DmsAltBox.Body>
 *   <DmsAltBox.Footer>
 *     <Typography>Footer content goes here.</Typography>
 *   </DmsAltBox.Footer>
 * </DmsAltBox.Card>
 * 
 * Author: André Tragancin
 */
const DmsAltBox = exports.DmsAltBox = {
  Card: DmsAltBoxCard,
  Header: DmsAltBoxHeader,
  HeaderRight: DmsAltBoxHeaderRight,
  Body: DmsAltBoxBody,
  Footer: DmsAltBoxFooter
};